import React from 'react';
import Phone from './Phone';

const Places: React.FC = () => (
  <section id="steder" className="py-20 bg-white">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        <div className="relative flex justify-center order-2 lg:order-1">
          <Phone src="/images/places.png" alt="Kart over Stempz-steder, med listen som kan dras ned" />
          <Phone
            src="/images/cards.png"
            alt="Lojalitetskort stablet i appen"
            className="hidden xl:block absolute -right-16 bottom-8 scale-75 origin-bottom"
          />
        </div>
        <div className="order-1 lg:order-2">
          <p className="text-sm font-semibold tracking-[0.18em] text-teal-700 mb-3">STEDER</p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-5">
            Se hvor du kan stemple.
          </h2>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Kartet viser Stempz-stedene rundt deg, med navn på nålen og den
            blå prikken der du står. Listen kan dras ned, så kartet får plass.
          </p>
          <ul className="space-y-4 text-gray-700">
            <li className="flex gap-3">
              <span className="mt-1 h-2.5 w-2.5 shrink-0 rounded-full bg-teal-600" />
              Søk etter sted, og se om de har en deal eller kort du allerede har.
            </li>
            <li className="flex gap-3">
              <span className="mt-1 h-2.5 w-2.5 shrink-0 rounded-full bg-teal-600" />
              Åpne stedet for åpningstider, lojalitetskort og deals der.
            </li>
            <li className="flex gap-3">
              <span className="mt-1 h-2.5 w-2.5 shrink-0 rounded-full bg-teal-600" />
              Stempler, deals og nye kort samles i siste aktivitet på hjemskjermen.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default Places;
